import React, {ChangeEvent, useState} from "react";
import {
  Button, ButtonGroup, Form,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from "reactstrap";
import {hrefToObject, recoverPasswordFormValidation, toast} from "../../Utils/Utils";
import {faEye, faEyeSlash} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useDispatch, useSelector} from "react-redux";
import {AuthActions} from "../../Store/Auth/Slice";
import {RecoveryPasswordParams} from "../../Models/RecoveryPasswordParams";
import {RootState} from "../../Store/Reducers";
import {ModalActions} from "../../Store/Modal/Slice";
import {RECOVER_PASSWORD_MODAL} from "../../Store/Modal/Types";

export interface RecoveryPasswordForm {
  password?: string | boolean,
  repeatPassword?: string | boolean
}

const RecoveryPasswordModal = () => {

  const dispatch = useDispatch();
  const {LoadingReducer: {loadingRecoverPassword}, authReducer:{logged}} = useSelector((state: RootState) => state);
  const { code, user_id }: RecoveryPasswordParams = hrefToObject();
  const [form, setForm] = useState<RecoveryPasswordForm>({});
  const [show, setShow] = useState({
    password: false,
    repeatPassword: false
  });

  const handleChange = (event: ChangeEvent<HTMLInputElement>, objKey: string) => {
    const {value} = event?.target;
    setForm(prevState => ({...prevState, [objKey]: value}));
  };

  const handleClick = (isVisible:boolean, objKey:string) => {
    setShow(prevState => ({...prevState, [objKey]: !isVisible}));
  };

  const onSubmit = () => {
    const res = recoverPasswordFormValidation(form, logged);
    if(res) {
      return toast(res,'error');
    }
    if(logged){
      dispatch(AuthActions.changePassword(form));
    }else{
      dispatch(AuthActions.recoverPassword({...form,code, user_id}));
    }
  };

  const onKeyDown = (e:any) => e === "Enter" && onSubmit ();

  const closeRecoverPasswordModal = () => {
    dispatch(ModalActions.closeModal({modal:RECOVER_PASSWORD_MODAL}));
  };

  return (
    <Modal toggle={logged ?closeRecoverPasswordModal:()=>{}} isOpen size="sm">
      <ModalHeader>{logged ? 'Cambiar' : 'Restablecer'} contraseña</ModalHeader>
      <ModalBody>

       <Form>
         <FormGroup>
           <Label>
             {logged ? 'Contraseña actual:' :  'Nueva contraseña:'}
           </Label>
           <InputGroup>
             <input type={!show.password ? 'password' : 'text'}
                    onKeyDown={onKeyDown} className="form-control"
                    onChange={(value) => handleChange(value, 'password')}/>
             <InputGroupAddon addonType="append">
               <Button outline color="info" onClick={()=>handleClick(show?.password,'password')}>
                 {show.password ? <FontAwesomeIcon icon={faEyeSlash}/> : <FontAwesomeIcon icon={faEye}/>}
               </Button>
             </InputGroupAddon>
           </InputGroup>
         </FormGroup>

         <FormGroup>
           <Label>
             {logged ? 'Nueva contraseña:' : 'Repita la contraseña:'}
           </Label>
           <InputGroup>
             <input type={!show.repeatPassword ? 'password' : 'text'}
                    className="form-control"
                    onKeyDown={(e)=>onKeyDown(e)}
                    onChange={(value) => handleChange(value, 'repeatPassword')}/>
             <InputGroupAddon addonType="append">
               <Button outline color="info" onClick={()=>handleClick(show?.repeatPassword,'repeatPassword')}>
                 {show.repeatPassword ? <FontAwesomeIcon icon={faEyeSlash}/> : <FontAwesomeIcon icon={faEye}/>}
               </Button>
             </InputGroupAddon>
           </InputGroup>
         </FormGroup>
       </Form>

      </ModalBody>

      <ModalFooter>
        <ButtonGroup>
          {logged &&
            <Button onClick={closeRecoverPasswordModal} outline color="danger">
            Cerrar
          </Button>
          }
          <Button disabled={loadingRecoverPassword.status.isLoading()}
                  color="success" outline onClick={onSubmit}>
            { loadingRecoverPassword.status.isLoading() && <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"/>}
            Enviar
          </Button>
        </ButtonGroup>
      </ModalFooter>

    </Modal>
  );
};

export default RecoveryPasswordModal;
